import { createAction } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { showNotificationAsync } from '../notifications/actions';
import { RootState } from '../store';
import { selectProductsCollectionLoading } from './selectors';
import * as productsService from './service';
import { ProductDataModel } from './types';

interface SetProductsListLoadingPayload {
    namespace: string;
    isLoading: boolean;
}

export const setProductRecords = createAction(
    '@@products/SET_PRODUCT_RECORDS',
    (...payload: ProductDataModel[]) => ({ payload }),
);

export const setProductCollection = createAction<{
    namespace: string;
    next?: string;
    identifiers: Array<ProductDataModel['id']>;
}>('@@products/SET_PRODUCT_COLLECTION');

export const setProductsCollectionLoading = createAction<SetProductsListLoadingPayload>(
    '@@products/SET_PRODUCTS_COLLECTION_LOADING',
);

export const removeProduct = createAction<{
    namespace: string;
    productId: string;
}>('@@products/REMOVE_PRODUCT');

export function loadProductsCollectionAsync(
    namespace: string,
    filters: Parameters<typeof productsService.loadProducts>[0],
): ThunkAction<Promise<void>, RootState, undefined, AnyAction> {
    return async (dispatch, getState) => {
        const isLoading = selectProductsCollectionLoading(getState(), namespace);

        if (isLoading) {
            return;
        }

        dispatch(setProductsCollectionLoading({ namespace, isLoading: true }));

        try {
            const response = await productsService.loadProducts(filters);

            dispatch(setProductRecords(...response.records.products));
            dispatch(
                setProductCollection({
                    namespace,
                    next: response.next,
                    identifiers: response.products,
                }),
            );
        } catch (_error) {
            dispatch(showNotificationAsync('Не удалось загрузить данные.'));
        }

        dispatch(setProductsCollectionLoading({ namespace, isLoading: false }));
    };
}

export function removeProductFromCatalog(
    namespace: string,
    productId: string,
    catalogId: string,
): ThunkAction<Promise<void>, RootState, undefined, AnyAction> {
    return async (dispatch) => {
        try {
            await productsService.removeProduct(productId, catalogId);

            dispatch(removeProduct({ productId, namespace }));
        } catch (_error) {
            dispatch(showNotificationAsync('Не удалось удалить товар'));
        }
    };
}
